const isDialogRegistrationActive = state =>
  state.common.isDialogRegistrationActive ?? false

export { isDialogRegistrationActive }
